// extracted by mini-css-extract-plugin
export default {"start":"StartObszarow_start__JBLiu","blok":"StartObszarow_blok__-GAIz","tytul":"StartObszarow_tytul__eLRjS","blokStrony":"StartObszarow_blokStrony__cyFjk"};